import Component from '@glimmer/component';
import add from 'ember-math-helpers/helpers/add';
import { eq, and, lt, gt } from 'ember-truth-helpers';

interface Link {
  path: string;
  name: string;
}

interface OxfordLinksSignature {
  Args: {
    collection?: Link[];
  };
}

export default class OxfordLinksComponent extends Component<OxfordLinksSignature> {
  get total(): number {
    return this.args.collection?.length ?? 0;
  }

  <template>
    {{~#each @collection as |link index|~}}
      {{~#if (eq 1 this.total)~}}
        <a href={{link.path}} target="_blank" rel="noopener">{{link.name}}</a>
      {{~else~}}
        {{~if (eq this.total (add index 1)) " and "~}}
        <a href={{link.path}} target="_blank" rel="noopener">{{link.name}}</a>
        {{~if (and (lt (add index 1) this.total) (gt this.total 2)) ", "~}}
      {{~/if~}}
    {{~/each~}}
  </template>
}
